import React from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";

export default function ViewTransactionDescriptionModal({
  showTransactionDescription,
  setShowTransactionDescription,
  selectedTransaction,
}) {
  const handleCancelTransactionDescription = () => {
    setShowTransactionDescription(false);
  };

  

  return (
    <Modal
      title={"Item description"}
      show={showTransactionDescription}
      hide={handleCancelTransactionDescription}
    >
      <div className="flex flex-col min-h-170">
        <span className="my-auto">
          {selectedTransaction.description}
        </span>
        <div className="flex flex-row-reverse mt-auto">
          <PrimaryButton
            onClick={handleCancelTransactionDescription}
            text="Back"
          />
        </div>
      </div>
    </Modal>
  );
}


   